export const translation = {
  zenit: {
    ae: {
      siteTitle: 'مكافآتك | Zenit',
      subTitle: 'فز بمكافأة تصل قيمتها حتى',
      bottomTitle: 'وراهن على لعبتك المفضلة',
      bookmakerString: 'لمراهنات Zenit',
      rightString: 'جميع الحقوق محفوظة',
      rules: 'الشروط والأحكام',
      btnRegistration: 'سجّل'
    },
    bn: {
      siteTitle: 'আপনার বোনাস | Zenit',
      subTitle: '',
      bottomTitle: 'পর্যন্ত বোনাস জিতুন এবং আপনার পছন্দের খেলায় বাজি ধরুন',
      bookmakerString: 'বুকমেকার Zenit',
      rightString: 'সর্বস্বত্ব সংরক্ষিত',
      rules: 'শর্তাবলী',
      btnRegistration: 'নিবন্ধন করুন'
    },
    br: {
      siteTitle: 'Seus bônus | Zenit',
      subTitle: 'Ganhe um bônus de até',
      bottomTitle: 'e aposte no seu jogo favorito',
      bookmakerString: 'Casa de Apostas Zenit',
      rightString: 'Todos os direitos reservados',
      rules: 'Regras',
      btnRegistration: 'Registre-se'
    },
    de: {
      siteTitle: 'Ihre Boni | Zenit',
      subTitle: 'Gewinnen Sie einen Bonus von\xA0bis\xA0zu',
      bottomTitle: 'und wetten Sie auf Ihr Lieblingsspiel',
      bookmakerString: 'Buchmacher Zenit',
      rightString: 'Alle Rechte vorbehalten',
      rules: 'Regeln',
      btnRegistration: 'Registrieren'
    },
    en: {
      siteTitle: 'Your bonuses | Zenit',
      subTitle: 'Win a bonus of up to',
      bottomTitle: 'and bet on your favourite game',
      bookmakerString: 'Bookmaker Zenit',
      rightString: 'All rights reserved',
      rules: 'Rules',
      btnRegistration: 'Play'
    },
    fr: {
      siteTitle: 'Vos bonus | Zenit',
      subTitle: `Gagnez un bonus jusqu'à`,
      bottomTitle: 'et pariez sur votre jeu préféré',
      bookmakerString: 'Bookmaker Zenit',
      rightString: 'Tous droits réservés',
      rules: 'Conditions générales',
      btnRegistration: `S'enregistrer`
    },
    ir: {
      siteTitle: 'پاداش ورزش الکترونیکی را خانه ببر | بنگاه شرط‌بندی ZENIT',
      subTitle: ' پاداش روی بازی مورد علاقه‌تان برنده شوید',
      bottomTitle: 'تا حداکثر',
      bookmakerString: ' بنگاه شرط‌بندی Zenit',
      rightString: 'تمامی حقوق محفوظ است',
      rules: 'قوانین',
      btnRegistration: ' دریافت'
    },
    kz: {
      siteTitle: 'Киберспортқа бонус | БК Зенит',
      subTitle: '',
      bottomTitle: 'дейінгі бонусты алып, өзіңе ұнайтын ойынға бәс тік!',
      bookmakerString: "Зенит букмекерлік кеңсесі",
      rightString: "Барлық құқық қорғалған",
      rules: 'Ережелер',
      btnRegistration: 'Тіркелу'
    },
    mx: {
      siteTitle: 'Sus bonificaciones | Zenit',
      subTitle: 'Gane una bonificación de hasta',
      bottomTitle: 'y apueste en su juego favorito',
      bookmakerString: 'Casa de Apostas Zenit',
      rightString: 'Todos os direitos reservados',
      rules: 'Reglas',
      btnRegistration: 'Jugare'
    },
    ru: {
      siteTitle: 'Бонус на киберспорт | ZENIT',
      subTitle: 'Забери бонус до',
      bottomTitle: 'и ставь на любимую игру!',
      bookmakerString: 'Букмекерская контора «Зенит»',
      rightString: 'Все права защищены',
      rules: 'Правила',
      btnRegistration: 'Регистрация'
    },
    sw: {
      siteTitle: 'Bonasi zako | Zenit',
      subTitle: 'Jishindie bonasi ya hadi',
      bottomTitle: 'na uwekeze dau ya mchezo unaopenda!',
      bookmakerString: 'Alamisho Zenit',
      rightString: 'Haki zote zimehifadhiwa',
      rules: `Sheria na\xA0masharti`,
      btnRegistration: 'Jisajili'
    },
    tr: {
      siteTitle: 'Bonuslarınız | Zenit',
      subTitle: '',
      bottomTitle: 'kadar bir bonus kazanın ve en sevdiğiniz oyuna bahis oynayın',
      bookmakerString: 'Zenit Bahis Şirketi',
      rightString: 'Tüm hakları saklıdır',
      rules: 'Hüküm ve koşullar',
      btnRegistration: 'Kaydolun'
    },
    ua: {
      siteTitle: 'Бонус на киберспорт | ZENIT',
      subTitle: 'Забери бонус до',
      bottomTitle: 'и ставь на любимую игру!',
      bookmakerString: 'Букмекерская контора Зенит',
      rightString: 'Все права защищены',
      rules: 'Правила',
      btnRegistration: 'Регистрация'
    },
    uz: {
      siteTitle: 'Bonuslaring | Zenit',
      subTitle: '',
      bottomTitle: 'gacha bonus ol va sevimli o‘yiningga tik',
      bookmakerString: 'Zenit bukmekerlik kontorasi',
      rightString: 'Barcha huquqlar himoya qilinadi',
      rules: 'Qoidalar',
      btnRegistration: 'Ro‘yxatdan o‘tish'
    },
    vi: {
      siteTitle: 'Tiền thưởng của bạn | Zenit',
      subTitle: 'Giành được khoản tiền thưởng lên đến',
      bottomTitle: 'và đặt cược vào trò chơi yêu thích của bạn!',
      bookmakerString: 'Nhà cái Zenit',
      rightString: 'Bảo lưu mọi quyền',
      rules: 'Điều khoản và\xA0điều\xA0kiện',
      btnRegistration: 'Đăng ký'
    }
  },
  zenbet: {
    ae: {
      siteTitle: 'مكافآتك | «ZENBET»',
      subTitle: 'فز بمكافأة تصل قيمتها حتى',
      bottomTitle: 'وراهن على لعبتك المفضلة',
      bookmakerString: 'لمراهنات «ZENBET»',
      rightString: 'جميع الحقوق محفوظة',
      rules: 'الشروط والأحكام',
      btnRegistration: 'سجّل'
    },
    bn: {
      siteTitle: 'আপনার বোনাস | «ZENBET»',
      subTitle: '',
      bottomTitle: 'পর্যন্ত বোনাস জিতুন এবং আপনার পছন্দের খেলায় বাজি ধরুন',
      bookmakerString: 'বুকমেকার «ZENBET»',
      rightString: 'সর্বস্বত্ব সংরক্ষিত',
      rules: 'শর্তাবলী',
      btnRegistration: 'নিবন্ধন করুন'
    },
    br: {
      siteTitle: 'Reivindique seu bônus de e-sports | «ZENBET»',
      subTitle: 'ganhe um bônus de até',
      bottomTitle: 'e aposte no seu jogo favorito',
      bookmakerString: 'Casa de Apostas «ZENBET»',
      rightString: 'Todos os direitos reservados',
      rules: 'Regras',
      btnRegistration: 'Registre-se'
    },
    de: {
      siteTitle: 'Ihre Boni | «ZENBET»',
      subTitle: 'Gewinnen Sie einen Bonus von\xA0bis\xA0zu',
      bottomTitle: 'und wetten Sie auf Ihr Lieblingsspiel',
      bookmakerString: 'Buchmacher «ZENBET»',
      rightString: 'Alle Rechte vorbehalten',
      rules: 'Regeln',
      btnRegistration: 'Registrieren'
    },
    en: {
      siteTitle: 'Bonus 430 $ | Cybersport | «ZENBET»',
      subTitle: 'Win a bonus of up to',
      bottomTitle: 'and bet on your favourite game',
      bookmakerString: 'Bookmaker «ZENBET»',
      rightString: 'All rights reserved',
      rules: 'Rules',
      btnRegistration: 'Play'
    },
    fr: {
      siteTitle: 'Vos bonus | «ZENBET»',
      subTitle: `Gagnez un bonus jusqu'à`,
      bottomTitle: 'et pariez sur votre jeu préféré',
      bookmakerString: 'Bookmaker «ZENBET»',
      rightString: 'Tous droits réservés',
      rules: 'Conditions générales',
      btnRegistration: `S'enregistrer`
    },
    ir: {
      siteTitle: 'پاداش ورزش الکترونیکی را خانه ببر | بنگاه شرط‌بندی «ZENBET»',
      subTitle: ' پاداش روی بازی مورد علاقه‌تان برنده شوید',
      bottomTitle: 'تا حداکثر',
      bookmakerString: ' بنگاه شرط‌بندی «ZENBET»',
      rightString: 'تمامی حقوق محفوظ است',
      rules: 'قوانین',
      btnRegistration: ' دریافت'
    },
    kz: {
      siteTitle: 'Сенің бонустарың | БК «ZENBET»',
      subTitle: '',
      bottomTitle: 'дейінгі бонусты алып, өзіңе ұнайтын ойынға бәс тік!',
      bookmakerString: "«ZENBET» букмекерлік кеңсесі",
      rightString: "Барлық құқық қорғалған",
      rules: 'Ережелер',
      btnRegistration: 'Тіркелу'
    },
    mx: {
      siteTitle: 'Consiga bonificaciones para esports home | Bookmaker «ZENBET»',
      subTitle: 'Gane una bonificación de hasta',
      bottomTitle: 'y apueste en su juego favorito',
      bookmakerString: 'Casa de Apostas «ZENBET»',
      rightString: 'Todos os direitos reservados',
      rules: 'Reglas',
      btnRegistration: 'Jugare'
    },
    ru: {
      siteTitle: 'Твои бонусы | БК «ZENBET»',
      subTitle: 'Забери бонус до',
      bottomTitle: 'и ставь на любимую игру!',
      bookmakerString: 'Букмекерская контора «ZENBET»',
      rightString: 'Все права защищены',
      rules: 'Правила',
      btnRegistration: 'Регистрация'
    },
    sw: {
      siteTitle: 'Bonasi zako | «ZENBET»',
      subTitle: 'Jishindie bonasi ya hadi',
      bottomTitle: 'na uwekeze dau ya mchezo unaopenda!',
      bookmakerString: 'Alamisho «ZENBET»',
      rightString: 'Haki zote zimehifadhiwa',
      rules: `Sheria na\xA0masharti`,
      btnRegistration: 'Jisajili'
    },
    tr: {
      siteTitle: 'Bonuslarınız | «ZENBET»',
      subTitle: '',
      bottomTitle: 'kadar bir bonus kazanın ve en sevdiğiniz oyuna bahis oynayın',
      bookmakerString: '«ZENBET» Bahis Şirketi',
      rightString: 'Tüm hakları saklıdır',
      rules: 'Hüküm ve koşullar',
      btnRegistration: 'Kaydolun'
    },
    uz: {
      siteTitle: 'Bonuslaring | «ZENBET»',
      subTitle: '',
      bottomTitle: 'gacha bonus ol va sevimli o‘yiningga tik',
      bookmakerString: '«ZENBET» bukmekerlik kontorasi',
      rightString: 'Barcha huquqlar himoya qilinadi',
      rules: 'Qoidalar',
      btnRegistration: 'Ro‘yxatdan o‘tish'
    },
    vi: {
      siteTitle: 'Tiền thưởng của bạn | «ZENBET»',
      subTitle: 'Giành được khoản tiền thưởng lên đến',
      bottomTitle: 'và đặt cược vào trò chơi yêu thích của bạn!',
      bookmakerString: 'Nhà cái «ZENBET»',
      rightString: 'Bảo lưu mọi quyền',
      rules: 'Điều khoản và\xA0điều\xA0kiện',
      btnRegistration: 'Đăng ký'
    }
  }
}
